import { render, staticRenderFns } from "./Owners.vue?vue&type=template&id=9c32d378"
import script from "./Owners.vue?vue&type=script&lang=js"
export * from "./Owners.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports